export default {
  costdetail: {
    searchPlaceholder: '请输入供应商/来源单号查询',
    searchPlaceholder1: '请输入客户/来源单号查询',
    costType: '费用类型',
    docDate: '单据日期',
    dataSource: '数据类型',
    purOfficeName: '采购中心',
    supOfficeName: '供应商',
    orderType: '订单性质',
    sourceNo: '来源单号',
    sourceSeq: '来源项次',
    receiptNo: '收货单号',
    receiptSeq: '收货项次',
    purchaseNo: '采购单号',
    purchaseSeq: '项次',
    purchaseLineSeq: '项序',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    valuationUnitName: '计价单位',
    qty: '本次对账数量',
    unitPrice: '含税单价',
    taxIncludedAmount: '含税金额',
    taxAmount: '税额',
    taxTypeName: '税种',
    taxRateStr: '税率',
    currencyName: '币种',
    payTermsName: '付款条件',
    status: '状态',
    status1: '已对账',
    status2: '未对账',
    labelName: '仅显示未对账资料',
    billPrice: '对账单价',
    billAmount: '对账金额',
    detailSearchPlaceholder: '请输入料号进行查询',
    purchaseUnitNo: '采购中心',
    supOfficeNo: '供应商',
    totalInvoiceAmount: '总发票金额',
    totalBillAmount: '总对账金额',
    exportdetail: '导出明细',
    filename: '对账明细',
    back: '返回',
    feiyongDate: '费用时间',
    createBill: '创建对账单',
    costBill: '对账清单',
    exportName: '对账汇总'
  },
  bill: {
    searchPlaceholder: '请输入供应商/对账单号查询',
    supSearchPlaceholder: '客户/对账单号',
    billNo: '发票单号',
    billDate: '对账日期',
    purOfficeName: '采购中心',
    supOfficeName: '供应商',
    orderType: '订单性质',
    currencyName: '币种',
    payTermsName: '付款条件',
    taxTypeName: '税种',
    taxRateStr: '税率',
    invoiceTypeName: '发票类型',
    totalInvoicedAmount: '总发票金额',
    totalMoney: '总金额',
    erpBillNo: '外部单号',
    status: '状态',
    isAbnormal: '异常否',
    purchaseUnitNo: '采购中心',
    spec: '规格',
    goodsName: '品名',
    goodsNo: '料号',
    sourceNo: '来源单号',
    examine: '审核',
    invoice: '提醒开票',
    check: '核对发票',
    toss: '抛转ERP',
    confirmExamine: '是否审核',
    confirmToss: '是否抛转ERP',
    confirmRemove: '是否删除',
    confirmInvoice: '是否提醒开票',
    nokaili: '非开立对账单不可删除',
    confirmNullify: '是否作废',
    nopaozhuan: '已抛转对账单不可作废',
    costType: '费用类型',
    dataSource: '数据来源',
    sourceSeq: '项次',
    qty: '对账数量',
    unitPrice: '对账单价',
    taxIncludedAmount: '对账金额',
    isAbnormalReason: '异常原因',
    invoiceType: '发票类型',
    invoiceClassify: '发票种类',
    invoiceNo: '发票号码',
    invoiceDate: '发票日期',
    invoiceAmount: '发票金额',
    taxAmount: '税额',
    diffAmount: '税额',
    taxRate: '税率',
    isGoodsInvoice: '随货发票',
    abnormal: '异常',
    confirmCheck: '核对完成',
    settleOfficeName: '客户',
    confirmReviewed: '是否确认',
    input: '录发票',
    confirm: '确认',
    tableTitle: '发票维护',
    date: '对账日期',
    requiredInvoiceNo: '请输入发票号码',
    invoiceCode: '发票代码'
  },
  invoice: {
    invoiceClassify: '发票种类',
    invoiceType: '发票类型',
    dateRange: '发票日期范围',
    invoiceNo: '发票号码',
    invoiceDate: '发票日期',
    invoiceAmount: '发票金额',
    isGoodsInvoice: '是否随货发票',
    taxAmount: '税额',
    taxRate: '税率',
    isGoodsInvoiceOptions: ['是', '否']
  }
}
